var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mb-4 pa-5",attrs:{"fluid":""}},[_c('h1',{staticClass:"display-1 font-weight-bold mb-5"},[_vm._v(" News ")]),_c('NewsWidget',{attrs:{"mode":"default"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }